// components/Loader.tsx
import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Loader = ({ size = 40, thickness = 4, color = "primary" }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        minHeight: "100px",
      }}
    >
      <CircularProgress size={size} thickness={thickness} color={color} />
    </Box>
  );
};

export default Loader;
